import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import { breakpoint, color } from "../../configs/utilities"
import { Link } from "gatsby"
import logo from "../../assets/footer/logo.svg"
import { LayoutWrapper } from "../common/wrappers/Wrappers"

const Footer = () => {
  const data = useStaticQuery(graphql`
    {
      allFooterJson {
        edges {
          node {
            text
            path
          }
        }
      }
      allFooterIconsJson {
        edges {
          node {
            image {
              publicURL
            }
            path
          }
        }
      }
    }
  `)

  return (
    <Wrapper>
      <LayoutWrapper>
        <Content>
          <ItemsWrapper>
            <Logo>
              <Link to="/">
                <img src={logo} alt="logo" />
              </Link>
            </Logo>
            <Links>
              {data.allFooterJson.edges.map((item, index) => {
                return (
                  <Link to={item.node.path} key={index}>
                    <p>{item.node.text}</p>
                  </Link>
                )
              })}
            </Links>
            <Icons>
              {data.allFooterIconsJson.edges.map((item, index) => {
                return (
                  <a
                    href={item.node.path}
                    key={index}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={item.node.image.publicURL}
                      alt="social logos"
                      width="25"
                      height="25"
                    />
                  </a>
                )
              })}
            </Icons>
          </ItemsWrapper>

          <Bottom>
            <CookiePrivacy>
              <Link to="/cookie-statement">Cookie Statement</Link>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </CookiePrivacy>
            <Rights>©moverbility 2023, All Rights Reserved</Rights>
          </Bottom>
        </Content>
      </LayoutWrapper>
    </Wrapper>
  )
}

export default Footer

const Wrapper = styled.div`
  background: ${color.black};
  color: ${color.white};
`

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 30px 0 20px;

  a {
    color: ${color.white};
  }

  @media screen and (min-width: ${breakpoint.lg}) {
    padding: 30px 0 20px;
  }
`

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: ${breakpoint.lg}) {
    flex-direction: row;
    justify-content: space-between;
  }
`

const Logo = styled.div`
  img {
    width: 100%;
    max-width: 150px;
  }
`

const Links = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 30px;
  padding: 40px 0;
  font-size: 14px;
  font-weight: 200;

  @media screen and (min-width: ${breakpoint.lg}) {
    flex-direction: row;
    column-gap: 20px;
    padding: 0;
  }
`

const Icons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 40px;
  padding: 10px 0;
  img {
    width: 100%;
    max-width: 25px;
  }
  @media screen and (min-width: ${breakpoint.lg}) {
    padding: 0;
  }
`

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  padding: 10px 0;
  opacity: 0.5;

  @media screen and (min-width: ${breakpoint.lg}) {
    flex-direction: row;
    justify-content: space-between;
  }
`

const CookiePrivacy = styled.div`
  display: flex;
  justify-content: center;
  column-gap: 20px;
  font-weight: 200;
  letter-spacing: 0.5px;
  font-size: 14px;
`

const Rights = styled.div`
  text-align: center;
  font-weight: 100;
  letter-spacing: 0.5px;
  font-size: 12px;
`
